import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  query getCompanyIdByUniqueSymbol($uniqueSymbol: ID!) {
    company(ref: $uniqueSymbol) {
      id
    }
  }
`);

/**
 * Temporary workaround to get company id by unique symbol for secondary listing selection
 */
export const getCompanyIdByUniqueSymbol = async (uniqueSymbol: string) => {
  if (!uniqueSymbol) return null;
  try {
    const { company } = await gqlClient.request(QUERY, { uniqueSymbol });
    return company.id ?? null;
  } catch (err) {
    console.error(`Failed to get company id for ${uniqueSymbol}`, err);
  }
};
